import { Button, Space, Table } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { EditOutlined } from "@ant-design/icons";

import { memo } from "react";
import { Link } from "react-router-dom";
import { PATH_DEPO_RECORDS, enumAdminRole } from "@configs";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { selectAuth } from "@redux";

interface IProps {
  data: any[];
  callback: () => void;
}
export const RecordsTable = memo(({ data, callback }: IProps) => {
  const { t } = useTranslation();
  const { auth } = useSelector(selectAuth);
  const dataSource: any[] = data;
  let columns: ColumnsType<any> = [
    {
      title: t("page.provider_name"),
      dataIndex: ["clinic", "clinicName"],
      key: "provider_name",      
      sorter: (a, b) => {
        return a.clinic.clinicName.localeCompare(b.clinic.clinicName);
      },
      fixed: "left",
      width: 20,
    },
    {
      title: t("page.township"),
      dataIndex: ["clinic", "township"],
      key: "township",
      width: 20,
      sorter: (a, b) => {
        return a.clinic.township.localeCompare(b.clinic.township);
      },
    },
    {
      title: t("page.reporting_from"),
      dataIndex: "reportingFrom",
      key: "reporting_from",
      width: 20,
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : t("page.empty")),
    },
    {
      title: t("page.reporting_to"),
      dataIndex: "reportingTo",
      key: "reporting_to",
      width: 20,
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : t("page.empty")),
    },
    {
      title: t("page.dmpa_im_New_client_Over_25"),
      dataIndex: ["contraception_clients", "dmpa_im_New_client_Over_25"],
      key: "dmpa_im_New_client_Over_25",
      width: 10,
    },
    {
      title: t("page.dmpa_im_New_client_Under_25"),
      dataIndex: ["contraception_clients", "dmpa_im_New_client_Under_25"],
      key: "dmpa_im_New_client_Under_25",
      width: 10,
    },
    {
      title: t("page.dmpa_im_Old_client_Over_25"),
      dataIndex: ["contraception_clients", "dmpa_im_Old_client_Over_25"],
      key: "dmpa_im_Old_client_Over_25",
      width: 10,
    },
    {
      title: t("page.dmpa_im_Old_client_Under_25"),
      dataIndex: ["contraception_clients", "dmpa_im_Old_client_Under_25"],
      key: "dmpa_im_Old_client_Under_25",
      width: 10,
    },
    {
      title: t("page.oc_pill_New_client_Over_25"),
      dataIndex: ["contraception_clients", "oc_pill_New_client_Over_25"],
      key: "oc_pill_New_client_Over_25",
      width: 10,
    },
    {
      title: t("page.oc_pill_New_client_Under_25"),
      dataIndex: ["contraception_clients", "oc_pill_New_client_Under_25"],
      key: "oc_pill_New_client_Under_25",
      width: 10,
    },
    {
      title: t("page.oc_pill_Old_client_Over_25"),
      dataIndex: ["contraception_clients", "oc_pill_Old_client_Over_25"],
      key: "oc_pill_Old_client_Over_25",
      width: 10,
    },
    {
      title: t("page.oc_pill_Old_client_Under_25"),
      dataIndex: ["contraception_clients", "oc_pill_Old_client_Under_25"],
      key: "oc_pill_Old_client_Under_25",
      width: 10,
    },
    {
      title: t("page.submitted_date"),
      dataIndex: "submittedDate",
      key: "submitted_date",
      width: 20,
      render: (date) => (date ? dayjs(date).format("DD-MM-YYYY") : t("page.empty")),
    },
    {
      title: t("page.submitted_by"),
      dataIndex: "submittedBy",
      key: "submitted_by",
      fixed: "right",
      width: 20,
      sorter: (a, b) => {
        return a.submittedBy.localeCompare(b.submittedBy);
      },
    },
    {
      title: t("page.actions"),
      key: "page_action",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Space>
            <Link
              style={{ pointerEvents: "auto" }}
              to={PATH_DEPO_RECORDS + `/${record._id}`}
            >
              <Button type="ghost" icon={<EditOutlined />} size={"small"} />
              <span>{t("page.edit")}</span>
            </Link>
          </Space>
        </Space>
      ),
    },
  ];

  if(auth?.userRole === enumAdminRole.CLINIC) {
    columns = columns.filter(column => column.key !== "submitted_by");
  }

  return <Table dataSource={dataSource} rowKey={"userId"} columns={columns} pagination={false} />;
});
